/**
 * @generated SignedSource<<74f1e225dba0d97b328e5b72b50e4892>>
 * @relayHash 4192c1b98be87d0cf8ac734fbe4fa216
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/539.0.0-2025-12-09T17:08:25.383Z/BuyRespLayoutRefetchQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PageDisplayEnum = "auctionsSearchAndBrowse" | "cart" | "catalog" | "checkout" | "email" | "favorites" | "homepage" | "mc" | "pdp" | "publication" | "searchAndBrowse" | "similarSold" | "visuallySimilar" | "%future added value";
export type types = "DESIGNER" | "SEARCH" | "SEARCH_HISTORY" | "SELLER" | "USER_PREFERENCE" | "%future added value";
export type BuyRespLayoutRefetchQuery$variables = {
  fetchBuy: boolean;
  fetchRegionalInfo?: boolean | null;
  fetchUser: boolean;
  first: number;
  followSearchPages?: ReadonlyArray<string | null> | null;
  followSearchTypes?: ReadonlyArray<types | null> | null;
  guestId?: string | null;
  isClient: boolean;
  isTrade: boolean;
  localeOrigin: string;
  page: number;
  pageDisplayEnum?: PageDisplayEnum | null;
  personalizationId?: string | null;
  priceBookName?: string | null;
  regions?: string | null;
  regionsList?: ReadonlyArray<string | null> | null;
  rerankGuestId?: string | null;
  rerankUserId?: string | null;
  rootId: string;
  showSeller: boolean;
  skipUser?: boolean | null;
  uriRef: string;
  userCountryCode?: string | null;
  userId?: string | null;
  userZipCode?: string | null;
};
export type BuyRespLayoutRefetchQuery$data = {
  readonly viewer: {
    readonly buyPage?: {
      readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly values: ReadonlyArray<{
          readonly displayName: string | null;
        } | null> | null;
      } | null> | null;
      readonly bottomModule: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"SharedBottomModule_bottomModule">;
      } | null> | null;
      readonly displayMaxNumberOfPages: number | null;
      readonly displayUriRef: string | null;
      readonly filters: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_filters">;
      } | null> | null;
      readonly internalBuyLinks: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"SharedRespLinksBlock_links">;
      } | null> | null;
      readonly meta: {
        readonly buyPageAvailableItemCount: number | null;
      } | null;
      readonly totalResults: number | null;
      readonly " $fragmentSpreads": FragmentRefs<"BuyRespCategoryTiles_itemSearch" | "BuyRespRefineMenu_itemSearch" | "BuyRespTopNav_buyPage" | "BuySharedBreadcrumbs_buyPage" | "BuySharedCMSFAQ_buyPage" | "BuySharedDescription_buyPage" | "BuySharedHead_buyPage" | "BuySharedPersonalizedSearchItems_itemSearch" | "BuySharedRefetchContainer_buyPage" | "BuySharedRelatedPages_buyPage" | "BuySharedResultContainer_buyPage" | "BuySharedTitle_buyPage" | "SharedFAQ_itemSearch" | "SharedFollowTopButton_itemSearch" | "SharedRecentSales_itemSearch" | "SharedRespLinksBlock_itemSearch" | "SharedSaveSearchContext_itemSearch" | "SharedWordpressArticles_itemSearch" | "SharedYMAL_itemSearch">;
    } | null;
    readonly isWordpressArticlesEnabled: boolean | null;
    readonly user?: {
      readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_user" | "BuyRespTopNav_user" | "BuySharedPersonalizedSearchItems_user" | "BuySharedResultContainer_user" | "SharedFollowSearchBanner_user" | "SharedFollowTopButton_user" | "SharedRecentSales_user" | "SharedSaveSearchContext_user" | "SharedYMAL_user">;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"BuyRespRefineMenu_viewer" | "BuySharedPersonalizedSearchItems_viewer" | "BuySharedRefetchContainer_viewer" | "BuySharedResultContainer_viewer" | "SharedRecentSales_viewer">;
  };
};
export type BuyRespLayoutRefetchQuery = {
  response: BuyRespLayoutRefetchQuery$data;
  variables: BuyRespLayoutRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchBuy"
},
v1 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "fetchRegionalInfo"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followSearchPages"
},
v5 = {
  "defaultValue": [
    "SEARCH",
    "USER_PREFERENCE"
  ],
  "kind": "LocalArgument",
  "name": "followSearchTypes"
},
v6 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "guestId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isTrade"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "localeOrigin"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v11 = {
  "defaultValue": "searchAndBrowse",
  "kind": "LocalArgument",
  "name": "pageDisplayEnum"
},
v12 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "personalizationId"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "priceBookName"
},
v14 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "regions"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regionsList"
},
v16 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankGuestId"
},
v17 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "rerankUserId"
},
v18 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rootId"
},
v19 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "showSeller"
},
v20 = {
  "defaultValue": true,
  "kind": "LocalArgument",
  "name": "skipUser"
},
v21 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uriRef"
},
v22 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v23 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userId"
},
v24 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v25 = {
  "alias": "isWordpressArticlesEnabled",
  "args": [
    {
      "kind": "Literal",
      "name": "featureName",
      "value": "WP_EDITORIAL"
    }
  ],
  "kind": "ScalarField",
  "name": "isEnabledByLocale",
  "storageKey": "isEnabledByLocale(featureName:\"WP_EDITORIAL\")"
},
v26 = {
  "kind": "Variable",
  "name": "priceBookName",
  "variableName": "priceBookName"
},
v27 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
},
v28 = {
  "kind": "Variable",
  "name": "userCountryCode",
  "variableName": "userCountryCode"
},
v29 = [
  {
    "kind": "Variable",
    "name": "buyPageId",
    "variableName": "rootId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "guestId",
    "variableName": "guestId"
  },
  {
    "kind": "Variable",
    "name": "localeOrigin",
    "variableName": "localeOrigin"
  },
  {
    "kind": "Variable",
    "name": "page",
    "variableName": "page"
  },
  (v26/*: any*/),
  {
    "kind": "Variable",
    "name": "regions",
    "variableName": "regions"
  },
  {
    "kind": "Variable",
    "name": "regionsList",
    "variableName": "regionsList"
  },
  (v27/*: any*/),
  (v28/*: any*/),
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "personalizationId"
  }
],
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalResults",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayMaxNumberOfPages",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayUriRef",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayName",
  "storageKey": null
},
v35 = [
  (v34/*: any*/)
],
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyPageAvailableItemCount",
  "storageKey": null
},
v37 = [
  (v26/*: any*/)
],
v38 = [
  {
    "kind": "Variable",
    "name": "userId",
    "variableName": "userId"
  }
],
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "width",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "link",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v42 = {
  "kind": "Variable",
  "name": "countryCode",
  "variableName": "userCountryCode"
},
v43 = {
  "kind": "Variable",
  "name": "zipCode",
  "variableName": "userZipCode"
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "count",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlLabel",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "linkReference",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mm",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "us",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hexCode",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedFilterName",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "key",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v59 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "anchorText",
  "storageKey": null
},
v60 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v61 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v62 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "ecommerceTrackingParams",
  "storageKey": null
},
v63 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "regionName",
  "storageKey": null
},
v64 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isComplimentary",
  "storageKey": null
},
v65 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCalculated",
  "storageKey": null
},
v66 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "totalAmount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmounts",
      "kind": "LinkedField",
      "name": "convertedAmounts",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "USD",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v67 = {
  "kind": "Variable",
  "name": "isTrade",
  "variableName": "isTrade"
},
v68 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v69 = {
  "alias": null,
  "args": null,
  "concreteType": "ConvertedAmountList",
  "kind": "LinkedField",
  "name": "convertedAmountList",
  "plural": true,
  "selections": [
    (v68/*: any*/),
    (v55/*: any*/)
  ],
  "storageKey": null
},
v70 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amountType",
  "storageKey": null
},
v71 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "textType",
  "storageKey": null
},
v72 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCountry",
  "storageKey": null
},
v73 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryCode",
  "storageKey": null
},
v74 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "browseUrl",
  "storageKey": null
},
v75 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contemporaryTrackingString",
  "storageKey": null
},
v76 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isNewListing",
  "storageKey": null
},
v77 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertical",
  "storageKey": null
},
v78 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "localizedPdpUrl",
  "storageKey": null
},
v79 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v80 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "unit",
    "storageKey": null
  },
  (v79/*: any*/)
],
v81 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "addLabel",
      "value": true
    },
    {
      "kind": "Literal",
      "name": "fields",
      "value": [
        "height",
        "width",
        "depth",
        "diameter",
        "length"
      ]
    },
    {
      "kind": "Literal",
      "name": "separator",
      "value": " "
    }
  ],
  "concreteType": "ItemDisplayMeasurementType",
  "kind": "LinkedField",
  "name": "display",
  "plural": true,
  "selections": (v80/*: any*/),
  "storageKey": "display(addLabel:true,fields:[\"height\",\"width\",\"depth\",\"diameter\",\"length\"],separator:\" \")"
},
v82 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemSize",
  "kind": "LinkedField",
  "name": "size",
  "plural": false,
  "selections": [
    (v79/*: any*/)
  ],
  "storageKey": null
},
v83 = {
  "kind": "Literal",
  "name": "addLabel",
  "value": false
},
v84 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemMeasurement",
  "kind": "LinkedField",
  "name": "measurement",
  "plural": false,
  "selections": [
    (v81/*: any*/),
    (v82/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "IN"
        }
      ],
      "concreteType": "ItemConvertedMeasurementsType",
      "kind": "LinkedField",
      "name": "convertedMeasurements",
      "plural": false,
      "selections": [
        (v39/*: any*/)
      ],
      "storageKey": "convertedMeasurements(unit:\"IN\")"
    },
    {
      "alias": "widthDimensions",
      "args": [
        (v83/*: any*/),
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "width"
          ]
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v80/*: any*/),
      "storageKey": "display(addLabel:false,fields:[\"width\"])"
    },
    {
      "alias": "heightDimensions",
      "args": [
        (v83/*: any*/),
        {
          "kind": "Literal",
          "name": "fields",
          "value": [
            "height"
          ]
        }
      ],
      "concreteType": "ItemDisplayMeasurementType",
      "kind": "LinkedField",
      "name": "display",
      "plural": true,
      "selections": (v80/*: any*/),
      "storageKey": "display(addLabel:false,fields:[\"height\"])"
    }
  ],
  "storageKey": null
},
v85 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isArt",
  "storageKey": null
},
v86 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemClassification",
  "kind": "LinkedField",
  "name": "classification",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "creationDate",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v87 = {
  "alias": null,
  "args": null,
  "concreteType": "Creator",
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": [
    (v34/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v88 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "attribution",
  "storageKey": null
},
v89 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v58/*: any*/)
  ],
  "storageKey": null
},
v90 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMultiSku",
  "storageKey": null
},
v91 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isRingItem",
  "storageKey": null
},
v92 = {
  "alias": null,
  "args": null,
  "concreteType": "VariableAttribute",
  "kind": "LinkedField",
  "name": "variableAttributes",
  "plural": true,
  "selections": [
    (v61/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "VariableAttributeSortType",
      "kind": "LinkedField",
      "name": "variableAttributeData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SwatchSort",
          "kind": "LinkedField",
          "name": "swatchSort",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Swatch",
              "kind": "LinkedField",
              "name": "swatch",
              "plural": false,
              "selections": [
                (v61/*: any*/),
                (v34/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "imageUrl",
                  "storageKey": null
                },
                (v41/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v41/*: any*/)
  ],
  "storageKey": null
},
v93 = {
  "kind": "Literal",
  "name": "page",
  "value": "searchAndBrowse"
},
v94 = [
  (v69/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "quantityDisplay",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "percentageOff",
    "storageKey": null
  },
  (v71/*: any*/),
  (v70/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPriceLabel",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "showPriceVariability",
    "storageKey": null
  }
],
v95 = {
  "alias": null,
  "args": [
    (v67/*: any*/),
    (v93/*: any*/),
    (v26/*: any*/)
  ],
  "concreteType": "ItemDisplayPriceType",
  "kind": "LinkedField",
  "name": "displayPrice",
  "plural": true,
  "selections": (v94/*: any*/),
  "storageKey": null
},
v96 = [
  {
    "kind": "Literal",
    "name": "formatType",
    "value": "MOBILE"
  }
],
v97 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewParagraph",
  "kind": "LinkedField",
  "name": "paragraphs",
  "plural": true,
  "selections": [
    (v54/*: any*/),
    (v56/*: any*/),
    {
      "alias": "mobileText",
      "args": (v96/*: any*/),
      "kind": "ScalarField",
      "name": "text",
      "storageKey": "text(formatType:\"MOBILE\")"
    }
  ],
  "storageKey": null
},
v98 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v34/*: any*/),
    (v89/*: any*/)
  ],
  "storageKey": null
},
v99 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewCategorySegments",
  "kind": "LinkedField",
  "name": "paragraphAttributeNames",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "period",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "origin",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "style",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "periodPrefix",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v100 = {
  "alias": "mobileTitle",
  "args": (v96/*: any*/),
  "kind": "ScalarField",
  "name": "title",
  "storageKey": "title(formatType:\"MOBILE\")"
},
v101 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "masterOrZoomPath",
  "storageKey": null
},
v102 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "smallPath",
  "storageKey": null
},
v103 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemPhotoVersion",
  "kind": "LinkedField",
  "name": "versions",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "webPath",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v104 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v105 = {
  "alias": "carouselPhotos",
  "args": [
    {
      "kind": "Literal",
      "name": "limit",
      "value": 2
    }
  ],
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v101/*: any*/),
    (v102/*: any*/),
    (v103/*: any*/),
    (v41/*: any*/),
    (v104/*: any*/)
  ],
  "storageKey": "photos(limit:2)"
},
v106 = {
  "alias": null,
  "args": null,
  "concreteType": "pdpMetaItems",
  "kind": "LinkedField",
  "name": "pdpMeta",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "topQuery",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v107 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isStorefrontOnly",
  "storageKey": null
},
v108 = [
  {
    "kind": "Literal",
    "name": "limit",
    "value": 1
  }
],
v109 = {
  "alias": null,
  "args": (v108/*: any*/),
  "concreteType": "viewInRoomPhotos",
  "kind": "LinkedField",
  "name": "viewInRoomPhotos",
  "plural": true,
  "selections": [
    (v104/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "src",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotosCenterPosition",
      "kind": "LinkedField",
      "name": "centerPosition",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "top",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "left",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "viewInRoomPhotosComparatorWidth",
      "kind": "LinkedField",
      "name": "comparatorWidth",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pixel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "inches",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "viewInRoomPhotos(limit:1)"
},
v110 = {
  "condition": "showSeller",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "seller",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SellerProfile",
          "kind": "LinkedField",
          "name": "sellerProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "company",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ]
},
v111 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchTerm",
  "storageKey": null
},
v112 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "itemId",
  "storageKey": null
},
v113 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 28
  }
],
v114 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isFurniture",
  "storageKey": null
},
v115 = {
  "alias": null,
  "args": null,
  "concreteType": "ItemCreator",
  "kind": "LinkedField",
  "name": "creators",
  "plural": true,
  "selections": [
    (v88/*: any*/),
    (v87/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v116 = {
  "alias": null,
  "args": null,
  "concreteType": "ShipmentQuote",
  "kind": "LinkedField",
  "name": "shipmentQuotes",
  "plural": true,
  "selections": [
    (v64/*: any*/),
    (v65/*: any*/),
    (v66/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ShipmentServiceMethod",
      "kind": "LinkedField",
      "name": "serviceMethod",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Region",
          "kind": "LinkedField",
          "name": "region",
          "plural": false,
          "selections": [
            (v63/*: any*/),
            (v41/*: any*/)
          ],
          "storageKey": null
        },
        (v41/*: any*/)
      ],
      "storageKey": null
    },
    (v41/*: any*/)
  ],
  "storageKey": null
},
v117 = {
  "alias": null,
  "args": null,
  "concreteType": "QuickViewDisplayType",
  "kind": "LinkedField",
  "name": "quickViewDisplay",
  "plural": false,
  "selections": [
    (v52/*: any*/),
    (v100/*: any*/),
    (v97/*: any*/),
    (v98/*: any*/),
    (v99/*: any*/)
  ],
  "storageKey": null
},
v118 = {
  "alias": null,
  "args": null,
  "concreteType": "Address",
  "kind": "LinkedField",
  "name": "address",
  "plural": false,
  "selections": [
    (v72/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v119 = {
  "alias": "productPhotos",
  "args": (v108/*: any*/),
  "concreteType": "ItemPhoto",
  "kind": "LinkedField",
  "name": "photos",
  "plural": true,
  "selections": [
    (v102/*: any*/),
    (v101/*: any*/),
    (v103/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": "photos(limit:1)"
},
v120 = {
  "alias": null,
  "args": null,
  "concreteType": "Seller",
  "kind": "LinkedField",
  "name": "seller",
  "plural": false,
  "selections": [
    (v61/*: any*/),
    (v41/*: any*/)
  ],
  "storageKey": null
},
v121 = {
  "alias": null,
  "args": null,
  "concreteType": "LinkData",
  "kind": "LinkedField",
  "name": "linkData",
  "plural": false,
  "selections": [
    (v57/*: any*/),
    (v56/*: any*/),
    (v58/*: any*/)
  ],
  "storageKey": null
},
v122 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "zipCode",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "country",
    "storageKey": null
  },
  (v41/*: any*/)
],
v123 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  },
  {
    "kind": "Variable",
    "name": "pages",
    "variableName": "followSearchPages"
  },
  {
    "kind": "Variable",
    "name": "types",
    "variableName": "followSearchTypes"
  }
],
v124 = [
  (v42/*: any*/),
  (v43/*: any*/)
],
v125 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RegionsByZipCode",
    "kind": "LinkedField",
    "name": "regionsByZipCode",
    "plural": true,
    "selections": (v35/*: any*/),
    "storageKey": null
  },
  (v41/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v18/*: any*/),
      (v19/*: any*/),
      (v20/*: any*/),
      (v21/*: any*/),
      (v22/*: any*/),
      (v23/*: any*/),
      (v24/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "BuyRespLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v25/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuySharedRefetchContainer_viewer"
          },
          {
            "condition": "fetchBuy",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "buyPage",
                "args": (v29/*: any*/),
                "concreteType": "ItemSearchQueryConnection",
                "kind": "LinkedField",
                "name": "itemSearch",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "kind": "LinkedField",
                    "name": "appliedFilters",
                    "plural": true,
                    "selections": [
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": (v35/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetaData",
                    "kind": "LinkedField",
                    "name": "meta",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "kind": "LinkedField",
                    "name": "filters",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuyRespRefineMenu_filters"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BottomModule",
                    "kind": "LinkedField",
                    "name": "bottomModule",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedBottomModule_bottomModule"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedRefetchContainer_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedBreadcrumbs_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedTitle_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedRelatedPages_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedResultContainer_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedRecentSales_itemSearch"
                  },
                  {
                    "args": (v37/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "SharedYMAL_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedDescription_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedHead_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuySharedCMSFAQ_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedFAQ_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedWordpressArticles_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedRespLinksBlock_itemSearch"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "internalBuyLinks",
                    "plural": true,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedRespLinksBlock_links"
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuyRespRefineMenu_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuyRespTopNav_buyPage"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedSaveSearchContext_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "SharedFollowTopButton_itemSearch"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "BuyRespCategoryTiles_itemSearch"
                  },
                  {
                    "args": (v37/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "BuySharedPersonalizedSearchItems_itemSearch"
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "skipUser",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v38/*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuyRespRefineMenu_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuyRespTopNav_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuySharedResultContainer_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "BuySharedPersonalizedSearchItems_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedRecentSales_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedYMAL_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedSaveSearchContext_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedFollowTopButton_user"
                      },
                      {
                        "args": null,
                        "kind": "FragmentSpread",
                        "name": "SharedFollowSearchBanner_user"
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuyRespRefineMenu_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuySharedResultContainer_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SharedRecentSales_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "BuySharedPersonalizedSearchItems_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v21/*: any*/),
      (v9/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v19/*: any*/),
      (v3/*: any*/),
      (v10/*: any*/),
      (v18/*: any*/),
      (v0/*: any*/),
      (v24/*: any*/),
      (v22/*: any*/),
      (v1/*: any*/),
      (v23/*: any*/),
      (v12/*: any*/),
      (v6/*: any*/),
      (v17/*: any*/),
      (v16/*: any*/),
      (v2/*: any*/),
      (v20/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Operation",
    "name": "BuyRespLayoutRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v25/*: any*/),
          {
            "alias": "video",
            "args": null,
            "concreteType": "VideoVimeo",
            "kind": "LinkedField",
            "name": "itemVideo",
            "plural": false,
            "selections": [
              {
                "alias": "videoThumb",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "pad",
                    "value": false
                  },
                  {
                    "kind": "Literal",
                    "name": "size",
                    "value": "w295h166"
                  }
                ],
                "kind": "ScalarField",
                "name": "thumbnail",
                "storageKey": "thumbnail(pad:false,size:\"w295h166\")"
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "height",
                "storageKey": null
              },
              (v39/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "VideoVimeoFile",
                "kind": "LinkedField",
                "name": "fileByVideoSize",
                "plural": false,
                "selections": [
                  (v40/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v41/*: any*/),
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "guestId",
                    "variableName": "rerankGuestId"
                  },
                  {
                    "kind": "Variable",
                    "name": "userId",
                    "variableName": "rerankUserId"
                  }
                ],
                "kind": "ScalarField",
                "name": "isEligibleForRerank",
                "storageKey": null
              },
              {
                "alias": "locations",
                "args": [
                  (v42/*: any*/),
                  {
                    "kind": "Literal",
                    "name": "facetLimit",
                    "value": 10
                  },
                  {
                    "kind": "Literal",
                    "name": "facetName",
                    "value": "location"
                  },
                  (v27/*: any*/),
                  (v43/*: any*/)
                ],
                "concreteType": "ItemFacetsQueryConnection",
                "kind": "LinkedField",
                "name": "itemFacetSearch",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemFacetsQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v44/*: any*/),
                          (v34/*: any*/),
                          (v45/*: any*/),
                          (v46/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchBuy",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "buyPage",
                "args": (v29/*: any*/),
                "concreteType": "ItemSearchQueryConnection",
                "kind": "LinkedField",
                "name": "itemSearch",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseParsedParam",
                    "kind": "LinkedField",
                    "name": "appliedFilters",
                    "plural": true,
                    "selections": [
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseParsedParamValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v34/*: any*/),
                          (v45/*: any*/),
                          (v47/*: any*/),
                          (v46/*: any*/),
                          (v44/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FilterPropertiesType",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                              (v48/*: any*/),
                              (v49/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v50/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canBeDismissed",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "clearAllLinkReference",
                        "storageKey": null
                      },
                      (v51/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MetaData",
                    "kind": "LinkedField",
                    "name": "meta",
                    "plural": false,
                    "selections": [
                      (v36/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "header",
                        "storageKey": null
                      },
                      (v52/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "topQueries",
                        "storageKey": null
                      },
                      (v53/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canonical",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "disableIndexing",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "microdata",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "next",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "prev",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LanguageAnnotations",
                        "kind": "LinkedField",
                        "name": "languageAnnotations",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "href",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hrefLang",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseFilter",
                    "kind": "LinkedField",
                    "name": "filters",
                    "plural": true,
                    "selections": [
                      (v33/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "totalCount",
                        "storageKey": null
                      },
                      (v51/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "originalFilterName",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseFilterValue",
                        "kind": "LinkedField",
                        "name": "values",
                        "plural": true,
                        "selections": [
                          (v44/*: any*/),
                          (v34/*: any*/),
                          (v46/*: any*/),
                          (v45/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "linkable",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "stats",
                            "kind": "LinkedField",
                            "name": "stats",
                            "plural": true,
                            "selections": [
                              (v54/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "values",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v50/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FilterPropertiesType",
                            "kind": "LinkedField",
                            "name": "properties",
                            "plural": false,
                            "selections": [
                              (v48/*: any*/),
                              (v49/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "min",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "max",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v47/*: any*/),
                          (v55/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BottomModule",
                    "kind": "LinkedField",
                    "name": "bottomModule",
                    "plural": true,
                    "selections": [
                      (v52/*: any*/),
                      (v53/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "trackedAbTests",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pageType",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SortType",
                    "kind": "LinkedField",
                    "name": "sort",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortCurrentOption",
                        "kind": "LinkedField",
                        "name": "currentOption",
                        "plural": false,
                        "selections": [
                          (v45/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SearchBrowseSortAvailableOptions",
                        "kind": "LinkedField",
                        "name": "options",
                        "plural": true,
                        "selections": [
                          (v45/*: any*/),
                          (v46/*: any*/),
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "appliedPersonalizationList",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AbTestConfigV2UserVariant",
                    "kind": "LinkedField",
                    "name": "seoAbTestV2List",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "variant",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AbTestConfigV2",
                        "kind": "LinkedField",
                        "name": "config",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "testName",
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "breadcrumbs",
                    "plural": true,
                    "selections": [
                      (v56/*: any*/),
                      (v57/*: any*/),
                      (v58/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "relatedBuyPages",
                    "plural": true,
                    "selections": [
                      (v59/*: any*/),
                      (v60/*: any*/),
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "LinkData",
                    "kind": "LinkedField",
                    "name": "popularSearchesLink",
                    "plural": false,
                    "selections": [
                      (v56/*: any*/),
                      (v57/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchQueryEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchResult",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Item",
                            "kind": "LinkedField",
                            "name": "item",
                            "plural": false,
                            "selections": [
                              (v61/*: any*/),
                              (v62/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isOnHold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isSold",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "isUnavailable",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Seller",
                                "kind": "LinkedField",
                                "name": "seller",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "isAccessible",
                                    "storageKey": null
                                  },
                                  (v41/*: any*/),
                                  (v61/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ShipmentQuote",
                                "kind": "LinkedField",
                                "name": "shipmentQuotes",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ShipmentServiceMethod",
                                    "kind": "LinkedField",
                                    "name": "serviceMethod",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Region",
                                        "kind": "LinkedField",
                                        "name": "region",
                                        "plural": false,
                                        "selections": [
                                          (v47/*: any*/),
                                          (v41/*: any*/),
                                          (v63/*: any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v41/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v41/*: any*/),
                                  (v64/*: any*/),
                                  (v65/*: any*/),
                                  (v66/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v52/*: any*/),
                              {
                                "alias": "displayPriceTracking",
                                "args": [
                                  (v67/*: any*/),
                                  {
                                    "kind": "Variable",
                                    "name": "page",
                                    "variableName": "pageDisplayEnum"
                                  },
                                  (v26/*: any*/),
                                  (v28/*: any*/)
                                ],
                                "concreteType": "ItemDisplayPriceType",
                                "kind": "LinkedField",
                                "name": "displayPrice",
                                "plural": true,
                                "selections": [
                                  (v69/*: any*/),
                                  (v70/*: any*/),
                                  (v71/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Address",
                                "kind": "LinkedField",
                                "name": "address",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "englishCountryName",
                                    "storageKey": null
                                  },
                                  (v41/*: any*/),
                                  (v72/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v73/*: any*/),
                              (v74/*: any*/),
                              (v75/*: any*/),
                              (v76/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "personalizationType",
                                "storageKey": null
                              },
                              (v77/*: any*/),
                              (v78/*: any*/),
                              (v84/*: any*/),
                              (v85/*: any*/),
                              (v86/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ItemCreator",
                                "kind": "LinkedField",
                                "name": "creators",
                                "plural": true,
                                "selections": [
                                  (v87/*: any*/),
                                  (v41/*: any*/),
                                  (v88/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v89/*: any*/),
                              (v90/*: any*/),
                              (v91/*: any*/),
                              (v92/*: any*/),
                              (v95/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "QuickViewDisplayType",
                                "kind": "LinkedField",
                                "name": "quickViewDisplay",
                                "plural": false,
                                "selections": [
                                  (v97/*: any*/),
                                  (v98/*: any*/),
                                  (v99/*: any*/),
                                  (v52/*: any*/),
                                  (v100/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v105/*: any*/),
                              (v106/*: any*/),
                              (v107/*: any*/),
                              (v109/*: any*/),
                              {
                                "alias": "productPhotos",
                                "args": (v108/*: any*/),
                                "concreteType": "ItemPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v102/*: any*/),
                                  (v103/*: any*/),
                                  (v41/*: any*/)
                                ],
                                "storageKey": "photos(limit:1)"
                              },
                              (v41/*: any*/),
                              {
                                "alias": null,
                                "args": (v108/*: any*/),
                                "concreteType": "ItemPhoto",
                                "kind": "LinkedField",
                                "name": "photos",
                                "plural": true,
                                "selections": [
                                  (v103/*: any*/),
                                  (v41/*: any*/)
                                ],
                                "storageKey": "photos(limit:1)"
                              },
                              (v110/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v111/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "searchRequestId",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ItemSearchSponsored",
                    "kind": "LinkedField",
                    "name": "sponsored",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "maxAvailable",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ItemSearchSponsoredMetadata",
                        "kind": "LinkedField",
                        "name": "metadata",
                        "plural": true,
                        "selections": [
                          (v112/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "impressionTrackerLink",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "clickTrackerLink",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchCorrectionsType",
                    "kind": "LinkedField",
                    "name": "searchCorrections",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "classificationSearchTerm",
                        "storageKey": null
                      },
                      (v111/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "semanticSearchTerm",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": "soldItemResults",
                    "args": (v113/*: any*/),
                    "concreteType": "soldResultsConnection",
                    "kind": "LinkedField",
                    "name": "soldResults",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "soldResultsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v114/*: any*/),
                                  (v52/*: any*/),
                                  (v106/*: any*/),
                                  (v78/*: any*/),
                                  (v86/*: any*/),
                                  (v115/*: any*/),
                                  (v85/*: any*/),
                                  (v89/*: any*/),
                                  (v77/*: any*/),
                                  (v116/*: any*/),
                                  (v107/*: any*/),
                                  (v90/*: any*/),
                                  (v91/*: any*/),
                                  (v92/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      (v67/*: any*/),
                                      (v93/*: any*/)
                                    ],
                                    "concreteType": "ItemDisplayPriceType",
                                    "kind": "LinkedField",
                                    "name": "displayPrice",
                                    "plural": true,
                                    "selections": (v94/*: any*/),
                                    "storageKey": null
                                  },
                                  (v117/*: any*/),
                                  (v84/*: any*/),
                                  (v118/*: any*/),
                                  (v119/*: any*/),
                                  (v62/*: any*/),
                                  (v76/*: any*/),
                                  (v105/*: any*/),
                                  (v109/*: any*/),
                                  (v75/*: any*/),
                                  (v74/*: any*/),
                                  (v73/*: any*/),
                                  (v120/*: any*/),
                                  (v41/*: any*/),
                                  (v110/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "soldResults(first:28)"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 20
                      }
                    ],
                    "concreteType": "youMayAlsoLikeConnection",
                    "kind": "LinkedField",
                    "name": "youMayAlsoLike",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "youMayAlsoLikeEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v62/*: any*/),
                                  (v114/*: any*/),
                                  (v52/*: any*/),
                                  (v106/*: any*/),
                                  (v78/*: any*/),
                                  (v86/*: any*/),
                                  (v115/*: any*/),
                                  (v85/*: any*/),
                                  (v89/*: any*/),
                                  (v77/*: any*/),
                                  (v116/*: any*/),
                                  (v107/*: any*/),
                                  (v90/*: any*/),
                                  (v91/*: any*/),
                                  (v92/*: any*/),
                                  (v95/*: any*/),
                                  (v117/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ItemMeasurement",
                                    "kind": "LinkedField",
                                    "name": "measurement",
                                    "plural": false,
                                    "selections": [
                                      (v81/*: any*/),
                                      (v82/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v118/*: any*/),
                                  (v119/*: any*/),
                                  (v76/*: any*/),
                                  {
                                    "alias": null,
                                    "args": [
                                      {
                                        "kind": "Literal",
                                        "name": "size",
                                        "value": "thumb"
                                      }
                                    ],
                                    "kind": "ScalarField",
                                    "name": "firstPhotoWebPath",
                                    "storageKey": "firstPhotoWebPath(size:\"thumb\")"
                                  },
                                  (v75/*: any*/),
                                  (v74/*: any*/),
                                  (v73/*: any*/),
                                  (v120/*: any*/),
                                  (v41/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "youMayAlsoLike(first:20)"
                  },
                  (v53/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "BuyPageFrequentlyAskedQuestionType",
                    "kind": "LinkedField",
                    "name": "frequentlyAskedQuestions",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "question",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "answer",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "faqHeader",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "QuestionType",
                    "kind": "LinkedField",
                    "name": "questionsAnswers",
                    "plural": true,
                    "selections": [
                      (v41/*: any*/),
                      (v60/*: any*/),
                      (v52/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "answerCount",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AnswerType",
                        "kind": "LinkedField",
                        "name": "answers",
                        "plural": true,
                        "selections": [
                          (v61/*: any*/),
                          (v56/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "formattedCreatedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Seller",
                            "kind": "LinkedField",
                            "name": "author",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "SellerPreferences",
                                "kind": "LinkedField",
                                "name": "sellerPreferences",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "label",
                                    "storageKey": null
                                  },
                                  (v45/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "scrollLogo",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "first",
                        "value": 8
                      }
                    ],
                    "concreteType": "WordpressArticlesType",
                    "kind": "LinkedField",
                    "name": "editorialArticles",
                    "plural": false,
                    "selections": [
                      (v30/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "WordpressArticleType",
                        "kind": "LinkedField",
                        "name": "articles",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publishedDate",
                            "storageKey": null
                          },
                          (v52/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "WordpressArticleImageType",
                            "kind": "LinkedField",
                            "name": "imageUrl",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "full",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "subtitle",
                            "storageKey": null
                          },
                          (v40/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "source",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "editorialArticles(first:8)"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "InternalBuyLinkType",
                    "kind": "LinkedField",
                    "name": "internalBuyLinks",
                    "plural": true,
                    "selections": [
                      (v60/*: any*/),
                      (v59/*: any*/),
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "topCategoryL1",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isAttributePage",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "clearAppliedFiltersLinkReference",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Seller",
                    "kind": "LinkedField",
                    "name": "seller",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "isRewarded",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "listNames",
                            "value": [
                              "SELLER_REWARDS_1",
                              "SELLER_REWARDS_2"
                            ]
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "isAnchorListsMember",
                        "storageKey": "isAnchorListsMember(listNames:[\"SELLER_REWARDS_1\",\"SELLER_REWARDS_2\"])"
                      },
                      (v41/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "canFollowSearch",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "SearchBrowseCategoryTiles",
                    "kind": "LinkedField",
                    "name": "categoryTiles",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "rank",
                        "storageKey": null
                      },
                      (v121/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "image",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConvertedAmountList",
                        "kind": "LinkedField",
                        "name": "convertedAmountList",
                        "plural": true,
                        "selections": [
                          (v68/*: any*/),
                          (v55/*: any*/),
                          (v121/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "trackingCreative",
                        "storageKey": null
                      },
                      (v112/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": (v113/*: any*/),
                    "concreteType": "personalizedSearchItemsConnection",
                    "kind": "LinkedField",
                    "name": "personalizedSearchItems",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "personalizedSearchItemsEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ItemSearchResult",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Item",
                                "kind": "LinkedField",
                                "name": "item",
                                "plural": false,
                                "selections": [
                                  (v61/*: any*/),
                                  (v114/*: any*/),
                                  (v52/*: any*/),
                                  (v106/*: any*/),
                                  (v78/*: any*/),
                                  (v86/*: any*/),
                                  (v115/*: any*/),
                                  (v85/*: any*/),
                                  (v89/*: any*/),
                                  (v77/*: any*/),
                                  (v116/*: any*/),
                                  (v107/*: any*/),
                                  (v90/*: any*/),
                                  (v91/*: any*/),
                                  (v92/*: any*/),
                                  (v95/*: any*/),
                                  (v117/*: any*/),
                                  (v84/*: any*/),
                                  (v118/*: any*/),
                                  (v119/*: any*/),
                                  (v62/*: any*/),
                                  (v76/*: any*/),
                                  (v105/*: any*/),
                                  (v109/*: any*/),
                                  (v75/*: any*/),
                                  (v74/*: any*/),
                                  (v73/*: any*/),
                                  (v120/*: any*/),
                                  (v41/*: any*/),
                                  (v110/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v41/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "personalizedSearchItems(first:28)"
                  },
                  (v41/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "skipUser",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "condition": "fetchUser",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v38/*: any*/),
                    "concreteType": "User",
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isVerifiedTrade",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserPreferences",
                        "kind": "LinkedField",
                        "name": "preferences",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "measurementUnit",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v61/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AddressBook",
                        "kind": "LinkedField",
                        "name": "addressBook",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "personalAddress",
                            "plural": false,
                            "selections": (v122/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "proAddress",
                            "plural": false,
                            "selections": (v122/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Address",
                            "kind": "LinkedField",
                            "name": "addressList",
                            "plural": true,
                            "selections": (v122/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": "showStrategicPartnerFilter",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "STRATEGIC_PARTNER_FILTERING"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"STRATEGIC_PARTNER_FILTERING\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TradeFirmType",
                        "kind": "LinkedField",
                        "name": "tradeFirm",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "TradeFirmRewards",
                            "kind": "LinkedField",
                            "name": "rewards",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ParentProgram",
                                "kind": "LinkedField",
                                "name": "currentProgram",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "LoyaltyProgram",
                                    "kind": "LinkedField",
                                    "name": "programInfo",
                                    "plural": false,
                                    "selections": [
                                      (v47/*: any*/),
                                      (v41/*: any*/)
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v41/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canShowFolder",
                        "storageKey": null
                      },
                      {
                        "alias": "hasMerchandizingPermission",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "BUYER_FE_MERCH_TOOL"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"BUYER_FE_MERCH_TOOL\")"
                      },
                      {
                        "alias": "canShowStorefrontOnlyBadge",
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "name",
                            "value": "VIEW_STOREFRONT_ONLY_BADGE"
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "hasPermission",
                        "storageKey": "hasPermission(name:\"VIEW_STOREFRONT_ONLY_BADGE\")"
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canShowSellerName",
                        "storageKey": null
                      },
                      (v41/*: any*/),
                      {
                        "condition": "fetchUser",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": (v123/*: any*/),
                            "concreteType": "favoritesConnection",
                            "kind": "LinkedField",
                            "name": "favorites",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "favoritesEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Favorite",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v61/*: any*/),
                                      (v34/*: any*/),
                                      (v41/*: any*/),
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "__id",
                                            "storageKey": null
                                          }
                                        ]
                                      },
                                      (v104/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "cursor",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PageInfo",
                                "kind": "LinkedField",
                                "name": "pageInfo",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "endCursor",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "hasNextPage",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": (v123/*: any*/),
                            "filters": [],
                            "handle": "connection",
                            "key": "SharedSaveSearchContext_favorites",
                            "kind": "LinkedHandle",
                            "name": "favorites"
                          }
                        ]
                      }
                    ],
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "condition": "fetchRegionalInfo",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": "regionsInfo",
                "args": (v124/*: any*/),
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": (v125/*: any*/),
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v124/*: any*/),
                "concreteType": "RegionalInfo",
                "kind": "LinkedField",
                "name": "regionalInfo",
                "plural": true,
                "selections": (v125/*: any*/),
                "storageKey": null
              }
            ]
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/539.0.0-2025-12-09T17:08:25.383Z/BuyRespLayoutRefetchQuery",
    "metadata": {},
    "name": "BuyRespLayoutRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "44c172ab4982acc7a9245be72b46c66c";

export default node;
